import { openAppointmentModal } from './modal-appointment';

const contactsBtn = document.querySelector('.contacts-btn');

contactsBtn.addEventListener('click', openAppointmentModal);
